<template>
    <modal class="addHandWorkModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">新增调账</div>
        <div class="modal-body">
            <div class="tr-li td-box">
                <div class="lable-txt">渠道：</div>
                <div class="from-input">
                    <select-tree v-model="channelAutoID" placeholder="请选择渠道" :data="treeOrderChannel" title="渠道选择" :isMultiple="false"/>
                </div>
            </div>
            <div class="tr-li td-box">
                <div class="lable-txt">付款方式：</div>
                <div class="from-input">
                    <el-select v-model="Payment_ID" placeholder="请选择付款方式" value-key="item">
                        <el-option  v-for="item in payTypeList" :key="item.PAY_ID"  :label="item.PAY_NAME" :value="item.PAY_ID"> </el-option>
                    </el-select>
                </div>
            </div>
            <div class="tr-li td-box">
                <div class="lable-txt">调整金额：</div>
                <div class="from-input"><input type="number" ref="money" v-model="money"/></div>
            </div>
            <div class="notes">注：手工调账前，调账门店必须存在一道菜，菜品名为:手工调账，菜品可处于停售状态。</div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="confirm()">确认</button>
        </div>
    </modal>
</template>

<script>

//新增调账
export default {
    name:"addHandWorkModel",
    emits:["close","confirm"],
    props:{ 
        /**是否显示弹层 */
        isShow:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            /**调整金额 */
            money:0,
            /**付款方式数据 */
            payTypeList:[],
            /**选中的 付款方式 */
            Payment_ID:'',
            /**渠道 */
            orderChannel:[],
            channelAutoID:null
        }
    },
    computed:{
        //渠道数据
        treeOrderChannel(){
            let treeData=[];
            this.orderChannel?.forEach((group)=>{
                let json={
                    id:group.OrderChannelKind_AutoID,
                    name:group.OrderChannelKind_Code+group.OrderChannelKind_Name,
                    children:[],
                    Hierarchy:1
                }
                if(group.OrderChannelList){
                    group.OrderChannelList.forEach(item=>{
                        let children= Object.assign({
                            id:item.OrderChannel_AutoID,
                            name:item.OrderChannel_Code+'-'+item.OrderChannel_Name,
                            Hierarchy:2
                        },item);
                        json.children.push(children);
                    })
                }
                treeData.push(json);
            })
            return treeData;
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.init();
        });
    },
    watch:{
        isShow(newValue){
            if(newValue){
                this.init();
            }
        }
    },
    methods:{
        /**初始化数据 */
        init(){
            if(this.payTypeList.length==0){
                this.$cacheData.AllPayTypes().then((d)=>{
                    if(d){
                        let all=[]
                        d.forEach(item => {
                            item.PayTypes.forEach((type)=>{
                                all.push(type)
                            })
                        });
                        this.payTypeList=all;
                    }
                }).catch((e)=>{
                    this.$message.error('加载付款方式数据失败：'+e,);
                    console.log('加载付款方式数据失败：'+e);
                })
            }
            if(this.orderChannel.length==0){
                //渠道
                this.$cacheData.OrderChannel().then((d)=>{
                    this.orderChannel = d;
                    console.log(d)
                }).catch((e)=>{
                    this.$message.error('加载渠道数据失败：'+e,);
                    console.log('加载渠道数据失败：'+e);
                })
            }
            //开票金额
            this.invoiceMoney=0;
            //备注
            this.remark="";
        },
        /**关闭 */
        hide(){
            this.$emit("close");
        },
        /**点击确认 */
        confirm(){
            let money=Number(this.money).toFixed(2);
            if(!(money>0 || money<0)){
                this.$message.warning("请输入调整金额!");
                this.$refs.money.focus();
                return;
            }
            if(!this.Payment_ID){
                this.$message.warning("请先选择付款方式!");
                return;
            }
            if(!this.channelAutoID){
                this.$message.warning("请先选择渠道!");
                return;
            }
            this.userInfo=this.$auth.getUserInfo();
            let param={
                User_ID:this.userInfo?.User_ID,
                Operator_Name:this.userInfo?.Login_Name,//操作员
                Eat_CheckMoney:money, //调整金额
                Pay_ID :this.Payment_ID,//付款方式
                channel_ID:this.channelAutoID,//渠道id
            }
            const loading = this.$loading({
                text: "数据保存中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.ManualAccountAdjustment",param).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.$message.success("保存成功");
                    console.log("保存成功",d.ResponseBody);
                    this.$emit("confirm");
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error('数据保存失败：'+e.message);
                console.log('数据保存失败：',e);
            })
        }
        
    }
}
</script>

<style lang="scss">
@import "./addHandWorkModel.scss";
</style>